<template>
    <div>
        <ul class="list-inline">
            <li class="list-inline-item m-0 font-yellow">Reputación</li>
            <li class="list-inline-item m-0" v-show="this.total >= 0">
                <i class="far fa-star-half font-yellow" v-if="this.total == 0"></i>
                <i class="fas fa-star font-yellow" v-if="this.total >= 1"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 0.5"></i>
            </li>
            <li class="list-inline-item m-0" v-show="this.total >= 1.5">
                <i class="fas fa-star font-yellow" v-if="this.total >= 2"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 1.5"></i>
            </li>
            <li class="list-inline-item m-0" v-show="this.total >= 2.5">
                <i class="fas fa-star font-yellow" v-if="this.total >= 3"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 2.5"></i>
            </li>
            <li class="list-inline-item m-0" v-show="this.total >= 3.5">
                <i class="fas fa-star font-yellow" v-if="this.total >= 4"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 3.5"></i>
            </li>
            <li class="list-inline-item m-0" v-show="this.total >= 4.5">
                <i class="fas fa-star font-yellow" v-if="this.total >= 5"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 4.5"></i>
            </li>

            <li class="list-inline-item m-0 font-yellow">{{total.toFixed(1)}}</li>
            <li class="list-inline-item m-0 font-gray-dark mx-1">{{rating}} Valoraciones</li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'Rating',
    props:{
        students: Number,
        rating: Number
    },
    data() {
        return {
            total: 0,
        }
    },
    updated(){
        let total = this.rating / this.students
        if(total != NaN){
            this.total = total
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/#public/curse/components/view/RatingTrainer.vue